/**
 * Shared primitives for the routine-definition container, used by scoring,
 * visibility rules and the checklist builder alike.
 */
export function toNullableNumber(value) {
  if (value === '' || value === null || value === undefined) {
    return null
  }

  const parsedValue = Number(value)
  return Number.isFinite(parsedValue) ? parsedValue : null
}
